import React from "react";

const MAP = {
    online: { c: "text-radioactive border-radioactive/40 bg-radioactive/10", dot: "#00FF66", t: "ONLINE", live: true },
    offline: { c: "text-danger border-danger/40 bg-danger/10", dot: "#EF4444", t: "OFFLINE" },
    restarting: { c: "text-warning border-warning/40 bg-warning/10", dot: "#F59E0B", t: "RESTARTING" },
    maintenance: { c: "text-sky-400 border-sky-400/40 bg-sky-400/10", dot: "#38bdf8", t: "MAINTENANCE" },
    wiping: { c: "text-hazard border-hazard/40 bg-hazard/10", dot: "#FF6B00", t: "WIPING" },
    connected: { c: "text-radioactive border-radioactive/40 bg-radioactive/10", dot: "#00FF66", t: "CONNECTED", live: true },
    disconnected: { c: "text-danger border-danger/40 bg-danger/10", dot: "#EF4444", t: "DISCONNECTED" },
    demo: { c: "text-warning border-warning/40 bg-warning/10", dot: "#F59E0B", t: "DEMO MODE" },
    success: { c: "text-radioactive border-radioactive/40 bg-radioactive/10", dot: "#00FF66", t: "SUCCESS" },
    failed: { c: "text-danger border-danger/40 bg-danger/10", dot: "#EF4444", t: "FAILED" },
    active: { c: "text-radioactive border-radioactive/40 bg-radioactive/10", dot: "#00FF66", t: "ACTIVE" },
};

export default function StatusBadge({ status, label, testId, className = "" }) {
    const s = MAP[status] || { c: "text-muted-foreground border-border bg-muted", dot: "#8B949E", t: (label || status || "—").toUpperCase() };
    return (
        <span data-testid={testId}
            className={`inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 label-mono ${s.c} ${className}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${s.live ? "live-dot" : ""}`} style={{ background: s.dot }} />
            {label || s.t}
        </span>
    );
}
